import type { Choice } from "@memorang/types";
import { useMemo } from "react";
import { useAppTheme } from "../../../../useAppTheme";
import { useDevice } from "../../../../useDevice";
import Box from "../../../Box";
import InlineBlankFields, { type InlineBlankField } from "../InlineBlankFields";

export type TextCompletionField = {
	blankId: string;
	choices: Choice[];
};

type Props = {
	stem: string;
	fields: TextCompletionField[];
	values: Record<string, string>;
	onChangeValues: (values: Record<string, string>) => void;
	disabled?: boolean;
	correctValues?: Record<string, string>;
};

const toInlineBlankFields = (
	fields: TextCompletionField[],
): InlineBlankField[] =>
	fields.map(({ blankId, choices }) => ({ blankId, choices }));

const TextCompletion = ({
	stem,
	fields,
	values,
	onChangeValues,
	disabled = false,
	correctValues,
}: Props) => {
	const theme = useAppTheme();
	const { isMobile } = useDevice();

	const inlineFields = useMemo(() => toInlineBlankFields(fields), [fields]);

	return (
		<Box
			backgroundColor={isMobile ? undefined : theme.colors.surface}
			style={
				isMobile
					? undefined
					: {
							borderRadius: theme.roundness * 2,
							borderWidth: 1,
							borderColor: theme.colors.outlineVariant,
						}
			}
			padding={isMobile ? 0 : 16}
		>
			<InlineBlankFields
				stemText={stem}
				fields={inlineFields}
				values={values}
				onChangeValues={onChangeValues}
				disabled={disabled}
				correctValues={correctValues}
			/>
		</Box>
	);
};

export default TextCompletion;
